import { Skeleton } from '@mui/material';

const RowSkeleton = () => (
  <div className="w-full border-b flex py-2">
    <div className="p-4" />
    <div><Skeleton variant="rectangular" height={100} width={100} /></div>
    <div className="w-full px-4"><Skeleton variant="text" /></div>
  </div>
);

export const PostRowSkeleton = () => (
  <div className="w-full border rounded-md">
    <div className="w-full p-4 bg-hintgray dark:bg-darkgray" />
    <RowSkeleton />
    <RowSkeleton />
    <RowSkeleton />
  </div>
);
